var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiTokenDevelopmentTypes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1315.51,
    height: 340.909,
    viewBox: "0 0 1315.51 340.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_45469",
    x: 639.141,
    y: 62.508,
    width: 173.479,
    height: 156.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cef",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_45475",
    x: 504.662,
    y: 62.508,
    width: 173.479,
    height: 156.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cef",
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65880",
    "data-name": "Group 65880",
    transform: "translate(-301.99 -3682.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65842",
    "data-name": "Group 65842",
    transform: "translate(-54.681 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45464",
    "data-name": "Path 45464",
    d: "M1447.547-13673.937s-26.569-86.7,90.838-88.161c106.071-2.509,451.834-1.188,490.121-3,54.443-2.573,67.477-47.406,69.921-54.744.11-.327,4.032,0,4.032,0",
    transform: "translate(-1085.287 17693.518)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45463",
    "data-name": "Path 45463",
    d: "M1452.827-13678.615s-9.175-68.519,34.913-83.483c46.756-2.509,177.5-1.595,198.931-8.19,29.752-6.2,48.142-51.2,48.142-51.2",
    transform: "translate(-719.213 17694)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45479",
    "data-name": "Path 45479",
    d: "M2099.88-13673.937s26.569-86.7-90.838-88.161c-106.071-2.509-451.834-1.188-490.121-3-54.443-2.573-67.477-47.406-69.921-54.744-.11-.327-4.032,0-4.032,0",
    transform: "translate(-433.287 17693.518)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45480",
    "data-name": "Path 45480",
    d: "M1711.191-13678.615s8.432-68.519-32.087-83.483c-42.971-2.509-163.126-1.595-182.825-8.19-27.343-6.2-44.244-51.2-44.244-51.2",
    transform: "translate(-438.783 17694)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    opacity: 0.77
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65833",
    "data-name": "Group 65833",
    transform: "translate(-51.078 220.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65834",
    "data-name": "Group 65834",
    transform: "translate(-4 -93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45468",
    "data-name": "Path 45468",
    d: "M1312.078-14060.625l134.691,79.105,134.453-79.141-134.453-77.042Z",
    transform: "translate(-432 17693)",
    fill: "#0e8ece"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 357.07, 3555.3)",
    filter: "url(#Path_45469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45469-2",
    "data-name": "Path 45469",
    d: "M1581.188-14060.694l-.268,40.5-134.211,77.095v-38.521Z",
    transform: "translate(-789.07 14137.7)",
    fill: "#65bde9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 357.07, 3555.3)",
    filter: "url(#Path_45475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45475-2",
    "data-name": "Path 45475",
    d: "M1446.709-14060.694l.268,40.5,134.211,77.095v-38.521Z",
    transform: "translate(-923.55 14137.7)",
    fill: "#65bde9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "matrix(0.656, -0.755, 0.755, 0.656, 1023.492, 3671.741)",
    fill: "#fff",
    fontSize: 84,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiTokenDevelopmentTypes);
export default __webpack_public_path__ + "static/media/earnestroi-token-development-types.9473f1930607ca1ba16f5a959a496ea0.svg";
export { ForwardRef as ReactComponent };